<template>
  <div
    style="
      display: flex;
      height: 100%;
      overflow: hidden;
      padding: 0 20px 0 10px;
    "
  >
    <div class="flex flex-column" style="flex: 2; overflow-y: auto">
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        基本信息
      </div>
      <table class="invoice-detail-record-table" cellpadding="10">
        <tr>
          <td>状态</td>
          <td>
            <c_status
              v-if="
                state.model?.status != null && state.model?.status != undefined
              "
              arr-name="invoice_status"
              :value="state.model?.status"
            ></c_status>
          </td>
          <td>客户名称</td>
          <td>{{ state.model.customer_name }}</td>
          <td>发票抬头</td>
          <td>{{ state.model.title }}</td>
        </tr>
        <tr>
          <td style="white-space: nowrap">统一社会信用代码</td>
          <td>{{ state.model.s_unified_social_credit_identifier }}</td>
          <td>发票类型</td>
          <td>{{ state.model.d_invoice_name }}</td>
          <td>开票类型</td>
          <td>{{ state.model.d_invoice_name || "-" }}</td>
        </tr>
        <tr>
          <td>开票信息</td>
          <td>
            {{ state.model.invoice_nature == 0 ? "普通发票" : "增值税发票" }}
          </td>
          <td>开票种类</td>
          <td>{{ state.model.d_invoice_kind_name || "-" }}</td>
          <td>联系电话</td>
          <td>{{ state.model.contact_phone }}</td>
        </tr>
        <tr>
          <td>开票金额</td>
          <td colspan="5"><c_money :value="state.model?.amount" /></td>
        </tr>
        <tr>
          <td>申请说明</td>
          <td colspan="5">{{ state.model.invoice_remark || "-" }}</td>
        </tr>
      </table>
      <template v-if="state.model.status == 1">
        <div
          style="
            font-size: 13px;
            font-weight: 600;
            margin: 10px;
            border-bottom: 1px solid #e2e2e2;
            padding-bottom: 10px;
          "
        >
          开票操作
        </div>
        <table cellpadding="10">
          <tr>
            <td style="color: #a2a2a2; text-align: right; width: 100px">
              发票号：
            </td>
            <td>{{ state.model.invoice_number }}</td>
            <td style="color: #a2a2a2; text-align: right; width: 100px">
              开票日期：
            </td>
            <td>{{ state.model.invoice_date }}</td>
            <td style="color: #a2a2a2; text-align: right; width: 100px">
              开票备注：
            </td>
            <td>{{ state.model.check_remark }}</td>
          </tr>
          <tr>
            <td style="color: #a2a2a2; text-align: right; width: 100px">
              附件：
            </td>
            <td rowspan="3">
              <div style="width: 100%; display: flex; flex-wrap: wrap">
                <ul
                  v-for="item in state.model.invoice_attachment"
                  :key="item"
                  class="diffbank-detail-files"
                  style="margin-right: 20px"
                >
                  <li
                    style="
                      color: #1e90ff;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                    @click="toFile(item)"
                  >
                    {{ item.filename }}
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </table>
      </template>
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        开票日志
      </div>
      <div style="padding: 0 20px">
        <el-table
          ref="tableDom"
          :data="state.logData"
          v-loading="!Array.isArray(state.logData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            align="center"
          />
          <el-table-column
            label="操作时间"
            prop="update_time"
            width="200"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            prop="remark"
            label="备注"
            :formatter="$tab_ShowToolTip"
            :min-width="150"
          />
          <el-table-column
            prop="content"
            label="内容"
            :formatter="$tab_ShowToolTip"
            :min-width="350"
          />
          <el-table-column label="操作人" width="200">
            <template #default="{ row }">
              <text>{{ row.add_admin_name }}</text>
              <text>{{ "/" + row.add_department_name }}</text>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { invoiceapply_detail, invoiceapply_log } from "@/http/invoiceapply";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      if (props.id) {
        invoiceapply_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
          }
        });

        invoiceapply_log(props.id).then((res) => {
          if (res.status == 200) {
            state.logData = res.data.data?.list;
          }
        });
      }
    });

    const toFile = (item) => {
      window.open(item.file_url, "_blank");
    };
    return { state, toFile };
  },
};
</script>
<style scoped lang="less">
.invoice-detail-record-table {
  width: 100%;
  font-size: 14px;

  & > tr > td:first-child {
    width: 100px;
  }

  & td:nth-child(2n + 1) {
    color: #a2a2a2;
    text-align: right;
  }

  & td:nth-child(2n) {
    text-align: left;
  }
}

.diffbank-detail-files {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.7);

  &:hover {
    color: #a2a2a2;
  }
}
</style>
